/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const Keys: {
    Tab: 9;
    Enter: 13;
    Esc: 27;
    Space: 32;
    PageUp: 33;
    PageDown: 34;
    End: 35;
    Home: 36;
    Left: 37;
    Up: 38;
    Right: 39;
    Down: 40;
} = {
    Tab: 9,
    Enter: 13,
    Esc: 27,
    Space: 32,
    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,
    Left: 37,
    Up: 38,
    Right: 39,
    Down: 40,
};

export type Key = typeof Keys[keyof typeof Keys];
